import React, { Component } from "react";
import {
  Row,
  Col,
  Container,
  InputGroup,
  InputGroupAddon,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  FormText,
  Collapse
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// import './forma_cadastro.css'
import Header from "../../components/header/header";
import Footer from "../../components/statics/footer";
import "../profile/personal/profileScreen.css";
import {
  buyCredits,
  addCredits,
  getCard,
  makePayment
} from "../../providers/paymentProvider";
import Toast from "../../components/utils/Toast";
import { faTablets } from "@fortawesome/free-solid-svg-icons";

const method = {
  payment: 0,
  card: 1
};

class AddCreditScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      collapse_ticket: false,
      openPaymentMethod: false,
      paymentMethod: null,
      chargeInfo: {
        amount: "",
        holder_name: "",
        exp_month: "",
        exp_year: "",
        number: "",
        cvc: "",
        taxpayer: ""
      },
      errorMessage: "",
      card: {}
    };
  }

  onChangeChargeInfo = updateObj => {
    this.setState(prevState => ({
      ...prevState,
      chargeInfo: {
        ...prevState.chargeInfo,
        ...updateObj
      }
    }));
  };

  isValid = () => {
    const hasInvalidField = Object.values(this.state.chargeInfo).some(
      value => !value
    );
    return !hasInvalidField;
  };

  send = async e => {
    e.preventDefault();
    const { email, firstName, lastName, credits, _id, token } = this.props.user;

    if (!this.isValid()) {
      this.setState({ errorMessage: "Preencha todos os campos" });
      setTimeout(() => this.setState({ errorMessage: "" }), 800);
      return;
    }

    const payload = {
      ...this.state.chargeInfo,
      email,
      firstName,
      lastName,
      amount: this.state.chargeInfo.amount * 100
    };
    console.log(payload);

    //call api devaripay
    const result = await buyCredits(payload);

    if (result.error) {
      this.setState({ errorMessage: result.message });
      return;
    }

    //if success add credits
    const newCreditAmount =
      Number(this.state.chargeInfo.amount) + Number(credits);
    this.props.doAddCredits(newCreditAmount, _id, token);
  };

  quickPayment = async () => {
    const {
      email,
      firstName,
      lastName,
      customerId,
      taxPayer,
      _id,
      token,
      credits
    } = this.props.user;
    const payload = {
      amount: this.state.chargeInfo.amount * 100,
      email,
      first_name: firstName,
      last_name: lastName,
      customer: customerId,
      taxpayer: taxPayer
    };
    const result = await makePayment(payload);
    if (result.error) {
      this.setState({ errorMessage: result.message });
      return;
    }
    const newCreditAmount =
      Number(this.state.chargeInfo.amount) + Number(credits);
    this.props.doAddCredits(newCreditAmount, _id, token);
  };

  nextStep = async () => {
    const { hasCard, email } = this.props.user;
    if (hasCard) {
      const card = await getCard(email);
      if (!card.error) {
        this.setState({ card: card.result[0] });
      }
    }
    this.setState({ openPaymentMethod: true });
  };

  render_form_credit() {
    return (
      <React.Fragment>
        <div className="row justify-content-between align-items-center custom-card custom-card-selected">
          <h4 className="m-0">Cartão de Crédito</h4>
          <ul
            style={{ listStyle: "none", margin: 0, padding: 0 }}
            className="row"
          >
            <li style={{ paddingRight: 8 }}>
              <img
                style={{ width: 50, height: 50, objectFit: "contain" }}
                src={require("../../imagens/pagamentos/cielo-logo.png")}
              />
            </li>
            <li style={{ paddingRight: 8 }}>
              <img
                style={{ width: 50, height: 50, objectFit: "contain" }}
                src={require("../../imagens/pagamentos/Hipercard-logo-5.png")}
              />
            </li>
            <li style={{ paddingRight: 8 }}>
              <img
                style={{ width: 50, height: 50, objectFit: "contain" }}
                src={require("../../imagens/pagamentos/mastercard-logo.jpg")}
              />
            </li>
            <li style={{ paddingRight: 8 }}>
              <img
                style={{ width: 50, height: 50, objectFit: "contain" }}
                src={require("../../imagens/pagamentos/visa-logo.png")}
              />
            </li>
          </ul>
        </div>
        <div className="custom-card">
          <Form>
            {this.state.chargeInfo.amount > 0 ? (
              <h5>
                Valor: R${this.state.chargeInfo.amount},00 / Créditos:{" "}
                {this.state.chargeInfo.amount}
              </h5>
            ) : null}
            <FormGroup>
              <Label>Nome do titular</Label>
              <Input
                value={this.state.chargeInfo.holder_name}
                onChange={e =>
                  this.onChangeChargeInfo({ holder_name: e.target.value })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label>CPF</Label>
              <Input
                value={this.state.chargeInfo.taxpayer}
                onChange={e =>
                  this.onChangeChargeInfo({ taxpayer: e.target.value })
                }
              />
              <FormText>Somente números</FormText>
            </FormGroup>
            <FormGroup>
              <Label>Número do cartão</Label>
              <Input
                value={this.state.chargeInfo.number}
                onChange={e =>
                  this.onChangeChargeInfo({ number: e.target.value })
                }
              />
              {/* <FormFeedback>Oh noes! that name is already taken</FormFeedback> */}
            </FormGroup>
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label>Data de expiração</Label>
                  <div className="d-flex">
                    <Input
                      className="mr-2"
                      type="number"
                      placeholder="mm"
                      value={this.state.chargeInfo.exp_month}
                      onChange={e =>
                        this.onChangeChargeInfo({ exp_month: e.target.value })
                      }
                    />
                    <Input
                      className="ml-2"
                      type="number"
                      placeholder="aaaa"
                      value={this.state.chargeInfo.exp_year}
                      onChange={e =>
                        this.onChangeChargeInfo({ exp_year: e.target.value })
                      }
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>CVV</Label>
                  <Input
                    value={this.state.chargeInfo.cvc}
                    onChange={e =>
                      this.onChangeChargeInfo({ cvc: e.target.value })
                    }
                    placeholder="***"
                    type="number"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button color="success btn-block" onClick={this.send}>
              Finalizar pagamento
            </Button>
          </Form>
        </div>
      </React.Fragment>
    );
  }

  renderPayment() {
    const { hasCard } = this.props.user;
    return (
      <Row className="mb-5">
        {/* <div className="mt-4">
                    <h2 id="tipo-texto">Selecione o método de pagamento</h2>
                </div> */}
        <Col xs="12" sm="12">
          {hasCard ? (
            <div className="custom-card">
              <h4>Cartão Associado:</h4>
              <div className="d-flex">
                <p className="mr-2">{this.state.card.flag}</p>
                <p>**** **** **** {this.state.card.last_number}</p>
              </div>
              <Button color="success btn-block" onClick={this.quickPayment}>
                Confirmar pagamento
              </Button>
            </div>
          ) : (
            this.render_form_credit()
          )}
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <div>
        {/* <Header /> */}
        <div className="payment-page">
          <Container>
            <div className="mt-4">
              <h2 id="tipo-texto">Adicionar crédito à conta</h2>
              <h4 className="text-muted">
                Adicione créditos e tenha acesso as consultorias desejadas.
              </h4>
            </div>
            <Row>
              <Col xs="12" sm="12">
                <div className="custom-card">
                  <div className="mb-2">
                    <span>Digite o valor que deseja adicionar</span>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">R$</InputGroupAddon>
                    <Input
                      min={0}
                      max={1000}
                      type="number"
                      step="1"
                      value={this.state.chargeInfo.amount}
                      onChange={e =>
                        this.onChangeChargeInfo({ amount: e.target.value })
                      }
                    />
                    <InputGroupAddon addonType="append">
                      <Button onClick={() => this.nextStep()} color="success">
                        Continuar
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </div>
              </Col>
            </Row>
            {this.state.openPaymentMethod ? this.renderPayment() : null}
            {this.state.errorMessage ? (
              <Toast message={this.state.errorMessage} type="error" />
            ) : null}
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}

//export default AddCreditScreen;

const mapStateToProps = state => {
  return {
    user: state.user.userInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    doAddCredits: (amount, id, token) => dispatch(addCredits(amount, id, token))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCreditScreen);
